import React, { FC, useCallback, useState, useEffect } from 'react'
import { createStyles, makeStyles } from '@zn-material-ui'
import Store from 'store'
import { validatePhone } from '@utils'

import { SuccessType, CaptchaType } from '@components/SliderCaptcha'
import TextField from '@components/TextField'
import AreaSelect from '@components/AreaSelect'
import AppListDialog, { dataType } from './AppListDialog'
import CaptchaInput from '../Login/CaptchaInput'
import fork from './img/fork.png'
import { transform } from '@utils/intl_lang'
export type UnionLabelType = 'areaCode' | 'phoneNum' | 'captcha' | 'count'
export type OnChangeType = (label: UnionLabelType, value: string) => void

interface IProps {
  captchaObj: CaptchaType | null
  count: number
  phoneNum?: string
  visible: boolean
  identityCodeError: boolean
  setVisible: (visible: boolean) => void
  setCount: (count: number) => void
  phoneCaptchaImg: () => void
  updateCount: () => void
  onChange: (label: string, value: string | number) => void
  appListDialogVisible: boolean
  appList: dataType
  dialogTitle: string
  loginLoading: boolean
  onClose: () => void
  onSelectApp: (appId: string) => () => void
  onCaptSuccess: (success: SuccessType) => void
  onCaptInit: (captObj: CaptchaType | null) => void
  slideVisible?: boolean
  isCancelLogin: boolean
  resetLogin: () => void
  isPasswordType: boolean
}

const FreeLoginForm: FC<IProps> = ({
  slideVisible,
  isCancelLogin,
  captchaObj,
  ...props
}) => {
  const [phoneNum, setPhoneNum] = useState(props.phoneNum || '')
  const [captcha, setCaptcha] = useState('')
  const [phoneError, setPhoneErr] = useState(false)
  const classes = useStyles()
  const enableCaptcha = props.count === 0
  const area = Store.get('areaCode')

  const getCaptcha = () => {
    if (!phoneNum.trim()) {
      // '请填写手机号！'
      global.$message(transform('Login_enter_mobile_number'))
      return
    }
    if (!enableCaptcha || phoneError) {
      return
    }
    props.phoneCaptchaImg()
  }

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const val =
      area && +area !== 86
        ? !event.target.value.trim()
        : !validatePhone(event.target.value)
    setPhoneErr(val)
  }

  const onChange = useCallback(
    (label: UnionLabelType) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      switch (label) {
      case 'phoneNum':
        setPhoneNum(value)
        break
      case 'captcha':
        setCaptcha(value)
        break
      }
      props.onChange(label, value)
    },
    [phoneNum, captcha]
  )

  const onAreaChange = (v: string) => {
    const code = (v !== '86' && v) || ''
    if (code) {
      setPhoneErr(!phoneNum)
    } else {
      setPhoneErr(!validatePhone(phoneNum))
    }
    Store.set('areaCode', code)
  }

  const onCaptInit = (captchaObj: CaptchaType | null) => {
    props.onCaptInit(captchaObj)
  }

  const onCaptSuccess = (success: SuccessType) => {
    props.onCaptSuccess(success)
  }

  const onAccountChange = () => {
    setPhoneNum('')
  }

  useEffect(() => {
    setPhoneNum(phoneNum)
  }, [phoneNum])

  useEffect(() => {
    if (isCancelLogin) {
      props.resetLogin()
    }
  }, [isCancelLogin])

  return (
    <>
      <div className={classes.accountContainer}>
        <AreaSelect onChange={onAreaChange} />
        <TextField
          type="number"
          // '手机号格式错误' : '手机号'
          label={
            phoneError
              ? transform('Login_wrong_format_number')
              : transform('Login_mobile_number')
          }
          placeholder="请输入手机号"
          value={phoneNum}
          onChange={onChange('phoneNum')}
          onBlur={onBlur}
          error={phoneError}
          className={classes.name}
          InputClass={{ formControl: classes.inputText }}
        />
        {phoneNum.length ? (
          <div
            className={classes.delete}
            onClick={onAccountChange}
          >
            <img style={{ width: '17.5px', height: '17.5px' }} src={fork} alt="" />
          </div>
        ) : null}
      </div>
      <CaptchaInput
        captchaObj={captchaObj}
        count={props.count}
        phoneNum={phoneNum}
        setCount={props.updateCount}
        captcha={captcha}
        getCaptcha={getCaptcha}
        onChange={onChange('captcha')}
        identityCodeError={false}
        onSuccess={onCaptSuccess}
        onCaptInit={onCaptInit}
        slideVisible={slideVisible}
      />
      {props.appListDialogVisible && (
        <AppListDialog
          data={props.appList}
          title={props.dialogTitle}
          loading={props.loginLoading}
          handleClose={props.onClose}
          handleSelect={props.onSelectApp}
        />
      )}
    </>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    accountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      height: 60,
      marginTop: 25,
    },
    inputText: {
      paddingLeft: 68,
    },
    name: {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    delete: {
      position: 'absolute',
      bottom: '10px',
      right: '75px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }
  })
)

export default FreeLoginForm
